<div class="grv-card">
  <div class="grv-card__content">
    <div class="form-header">
      <span class="grv-text--medium-1 grv-weight--semibold"> {{ "INTAKE_FORM.CARD_HEADER" | translate }}</span>
      <span id="remove-form" *ngIf="showRemoveButton">
        <c1-privacy-icon [iconName]="'trash_blue'" [size]="'quark'"> </c1-privacy-icon>
        <a id="remove-button" role="button" tabindex="0" (click)="removeForm()">
          {{ "INTAKE_FORM.REMOVE_BUTTON" | translate }}
        </a>
      </span>
    </div>
    <div>
      <form [formGroup]="intakeFormGroup">
        <div formGroupName="intakeGroup">
          <div class="grv-form-field">
            <div class="grv-label__header">
              <label [for]="'fileNameInput-' + formId" class="grv-label grv-label--textfield">{{
                "INTAKE_FORM.FILE_NAME_LABEL" | translate
              }}</label>
              <span class="grv-label__info"> {{ getInputLength("fileName") }}/100 </span>
            </div>
            <input
              type="text"
              [id]="'fileNameInput-' + formId"
              formControlName="fileName"
              class="grv-textfield__input"
              [ngClass]="{ 'grv-textfield__input--error': showError('fileName', formId) || violatedHSHD?.['fileName-' + formId] }"
              [attr.aria-describedby]="hasError('fileName', formId) ? 'fileNameError-' + formId : null"
              [attr.aria-invalid]="hasError('fileName', formId) ? 'true' : null"
              aria-label="file name"
            />
            <span
              [id]="'fileNameError-' + formId"
              class="grv-form-field__helper grv-form-field__helper--error"
              *ngIf="hasError('fileName', formId)"
            >
              <div *ngIf="showError('fileName', formId); else genericError">
                {{ "INTAKE_FORM.REQUIRED_ERROR_LABEL" | translate }}
              </div>
              <ng-template #genericError>
                <div class="dynamic-error-message">
                  <p>
                    <gds-icon color="critical" size="medium" icon-name="caution-triangle-filled"></gds-icon>
                  </p>
                  <p>
                    {{ "INTAKE_FORM.CORRECTION_GENERIC_ERROR_MESSAGE" | translate }}
                  </p>
                </div>
              </ng-template>
            </span>
            <span class="grv-form-field__helper">{{ "INTAKE_FORM.FILE_NAME_EXAMPLE" | translate }}</span>
          </div>

          <div class="grv-form-field">
            <div class="grv-label__header">
              <label [for]="'fieldInput-' + formId" class="grv-label grv-label--textfield">{{
                "INTAKE_FORM.FIELD_LABEL" | translate
              }}</label>
              <span class="grv-label__info"> {{ getInputLength("field") }}/100 </span>
            </div>
            <input
              type="text"
              [id]="'fieldInput-' + formId"
              formControlName="field"
              class="grv-textfield__input"
              [ngClass]="{ 'grv-textfield__input--error': showError('field', formId) ||  violatedHSHD?.['field-' + formId] }"
              [attr.aria-describedby]="hasError('field', formId) ? 'fieldError-' + formId : null"
              [attr.aria-invalid]="hasError('field', formId) ? 'true' : null"
              aria-label="field or column name"
            />
            <span
              [id]="'fieldError-' + formId"
              class="grv-form-field__helper grv-form-field__helper--error"
              *ngIf="hasError('field', formId)"
            >
              <div *ngIf="showError('field', formId); else genericError">
                {{ "INTAKE_FORM.REQUIRED_ERROR_LABEL" | translate }}
              </div>
              <ng-template #genericError>
                <div class="dynamic-error-message">
                  <p>
                    <gds-icon color="critical" size="medium" icon-name="caution-triangle-filled"></gds-icon>
                  </p>
                  <p>
                    {{ "INTAKE_FORM.CORRECTION_GENERIC_ERROR_MESSAGE" | translate }}
                  </p>
                </div>
              </ng-template>
            </span>
          </div>

          <div class="correct-value-inputs">
            <div class="grv-form-field">
              <div class="grv-label__header">
                <label [for]="'incorrectValueInput-' + formId" class="grv-label grv-label--textfield">{{
                  "INTAKE_FORM.INCORRECT_VALUE_LABEL" | translate
                }}</label>
                <span class="grv-label__info"> {{ getInputLength("incorrectValue") }}/100 </span>
              </div>
              <input
                type="text"
                [id]="'incorrectValueInput-' + formId"
                formControlName="incorrectValue"
                class="grv-textfield__input"
                [ngClass]="{ 'grv-textfield__input--error': showError('incorrectValue', formId) || violatedHSHD?.['incorrectValue-' + formId] }"
                [attr.aria-describedby]="hasError('incorrectValue', formId) ? 'incorrectValueError-' + formId : null"
                [attr.aria-invalid]="hasError('incorrectValue', formId) ? 'true' : null"
              />
              <span
                [id]="'incorrectValueError-' + formId"
                class="grv-form-field__helper grv-form-field__helper--error"
                *ngIf="hasError('incorrectValue', formId)"
              >
                <div *ngIf="showError('incorrectValue', formId); else genericError">
                  {{ "INTAKE_FORM.REQUIRED_ERROR_LABEL" | translate }}
                </div>
                <ng-template #genericError>
                  <div class="dynamic-error-message">
                    <p>
                      <gds-icon color="critical" size="medium" icon-name="caution-triangle-filled"></gds-icon>
                    </p>
                    <p>
                      {{ "INTAKE_FORM.CORRECTION_GENERIC_ERROR_MESSAGE" | translate }}
                    </p>
                  </div>
                </ng-template>
              </span>
            </div>

            <c1-privacy-icon class="" [iconName]="'arrowRight'" [size]="'angstrem'"> </c1-privacy-icon>

            <div class="grv-form-field force-bottom-margin-24">
              <div class="grv-label__header">
                <label [for]="'correctValueInput-' + formId" class="grv-label grv-label--textfield">{{
                  "INTAKE_FORM.CORRECT_VALUE_LABEL" | translate
                }}</label>
                <span class="grv-label__info"> {{ getInputLength("correctValue") }}/100 </span>
              </div>
              <input
                type="text"
                [id]="'correctValueInput-' + formId"
                formControlName="correctValue"
                class="grv-textfield__input"
                [ngClass]="{ 'grv-textfield__input--error': showError('correctValue', formId) || violatedHSHD?.['correctValue-' + formId] }"
                [attr.aria-describedby]="hasError('correctValue', formId) ? 'correctValueError-' + formId : null"
                [attr.aria-invalid]="hasError('correctValue', formId) ? 'true' : null"
              />
              <span
                [id]="'correctValueError-' + formId"
                class="grv-form-field__helper grv-form-field__helper--error"
                *ngIf="hasError('correctValue', formId)"
              >
                <div *ngIf="showError('correctValue', formId); else genericError">
                  {{ "INTAKE_FORM.REQUIRED_ERROR_LABEL" | translate }}
                </div>
                <ng-template #genericError>
                  <div class="dynamic-error-message">
                    <p>
                      <gds-icon color="critical" size="medium" icon-name="caution-triangle-filled"></gds-icon>
                    </p>
                    <p>
                      {{ "INTAKE_FORM.CORRECTION_GENERIC_ERROR_MESSAGE" | translate }}
                    </p>
                  </div>
                </ng-template>
              </span>
            </div>
          </div>

          <div class="grv-form-field">
            <div class="grv-label__header">
              <label [for]="'explanationInput-' + formId" class="grv-label grv-label--textfield">{{
                "INTAKE_FORM.EXPLANATION_LABEL" | translate
              }}</label>
              <span class="grv-label__info"> {{ getInputLength("explanation") }}/250 </span>
            </div>
            <textarea
              type="text"
              [id]="'explanationInput-' + formId"
              formControlName="explanation"
              class="grv-textfield__textarea"
              [ngClass]="{ 'grv-textfield__textarea--error': showError('explanation', formId) || violatedHSHD?.['explanation-' + formId] }"
              [attr.aria-describedby]="hasError('explanation', formId) ? 'explanationError-' + formId : null"
              [attr.aria-invalid]="hasError('explanation', formId) ? 'true' : null"
            ></textarea>
            <span
              [id]="'explanationError-' + formId"
              class="grv-form-field__helper grv-form-field__helper--error"
              *ngIf="hasError('explanation', formId)"
            >
              <div *ngIf="showError('explanation', formId); else genericError">
                {{ "INTAKE_FORM.REQUIRED_ERROR_LABEL" | translate }}
              </div>
              <ng-template #genericError>
                <div class="dynamic-error-message">
                  <p>
                    <gds-icon color="critical" size="medium" icon-name="caution-triangle-filled"></gds-icon>
                  </p>
                  <p>
                    {{ "INTAKE_FORM.CORRECTION_GENERIC_ERROR_MESSAGE" | translate }}
                  </p>
                </div>
              </ng-template>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
